module.exports = __webpack_public_path__ + "static/alliance-franchise-logo-84a1e3bda7f9b91c70c88227fadfb055.png";